<template lang="pug">
.v-tags.tags(v-if="data" :id="data?.id")
	.tags__items(v-if="data.tabs" :class="[wrapMob ? 'tags__items--wrap-mob' : '']")
		template(v-for="item in data.tabs")
			a.tags__item(v-if="item.link" :href="item.link" :class="[item.active ? 'active' : '', item.image ? 'tags__item--image': '']")
				img.tags__item-image(v-if="item.image" :src="item.image")
				|  {{item.text}}
				img.tags__item-icon(v-if="item.icon" :src="item.icon")
			button.tags__item(v-else="" type="button" @click="item.active ? null : handleTabClick(item)" :class="{active: item.active}")
				img.tags__item-image(v-if="item.image" :src="item.image")
				|  {{item.text}}
				img.tags__item-icon(v-if="item.icon" :src="item.icon")
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";

export default {

	mixins: [
		sourceMixin
	],

	emits: [
			'emit-items',
			'emit-data'
	],

	props: {
		tags: {
			type: Object,
			default: null
		},

		wrapMob: {
			type: Boolean,
			default: null
		}
	},

	watch: {
		tags(state) {
			if (state) {
				this.data = state;
			}
		}
	},

	data() {
		return {
			data: null,
			active: null,
			loading: false
		}
	},

	mounted() {
		if (this.tags) {
			this.data = this.tags;
		}
	},

	methods: {
		dataSet(data, options = {}) {
			this.data = data;
			this.active = data.tabs?.find(item => item.active);
			if (window.location.pathname.indexOf('/local/') < 0 && options.updateUrl) {
				window.history.replaceState(null, null, data.remote);
			}

			if (data.items) {
				this.$emit('emit-items', data.items, data)
			}

			this.$emit('emit-data', data)
		},

		requestDataLoad(dataSetOptions) {
			if (this.loading) {
				return;
			}
			this.loading = true;
			this.dataLoad({
				url: this.data.remote,
				delay: false,
				method: 'POST',
				data: {
					id: dataSetOptions.id,
					bxajaxid: this.bxajaxid || this.data.bxajaxid
				},
			}, dataSetOptions);
		},

		handleTabClick(item) {
			this.requestDataLoad({id: item.id});
		}
	}
}

</script>